import request from "@/lib/axios";
// 加入购物车
export function addCartBatch(query) {
  return request({
    method: "POST",
    url: "/cart/addCartBatch",
    data: query
  });
}
// oe 列表查询
export function findOeList(query) {
  return request({
    method: "GET",
    url: "/findOe",
    params: query
  });
}
// oe 查询品牌件
export function findBrand(query) {
  return request({
    method: "GET",
    url: "/findBrand",
    params: query
  });
}
// oe  查询品类
export function findCategory(query) {
  return request({
    method: "GET",
    url: "/findCategory",
    params: query
  });
}
// 求购信息
export function findBuyInfo(query) {
  return request({
    method: "GET",
    url: "/findBuyInfo",
    params: query
  });
}

// 基础信息
export function partsBaseInfo(query) {
  return request({
    method: "GET",
    url: "/partsBaseInfo",
    params: query
  });
}
// 修改基础信息备注
export function updateBaseInfoRemark(query) {
  return request({
    method: "GET",
    url: "/updateBaseInfoRemark",
    params: query
  });
}
// 查询别名
export function findAliasInfo(query) {
  return request({
    method: "GET",
    url: "/findAliasInfo",
    params: query
  });
}
// 修改别名
export function updateAliasNames(query) {
  return request({
    method: "GET",
    url: "/updateAliasNames",
    params: query
  });
}
// 查询渠道价格
export function partsPrice(query) {
  return request({
    method: "GET",
    url: "/partsPrice",
    params: query
  });
}
// 替换件信息
export function partsReplace(query) {
  return request({
    method: "GET",
    url: "/partsReplace",
    params: query
  });
}
// 适用车型
export function partsGeneralCar(query) {
  return request({
    method: "GET",
    url: "/generalCar",
    params: query
  });
}

// 查询总成图
export function partKeySearchV(query) {
  return request({
    method: "GET",
    url: "/partKeySearchV2",
    params: query
  });
}

// 查询总成图
export function partAsPartsImageVo(query) {
  return request({
    method: "GET",
    url: "/partAsPartsImageVo",
    params: query
  });
}

// 查询品牌件 127.0.0.1:8080/findBrandPart
export function findBrandPart(query) {
  return request({
    method: "GET",
    url: "/findBrandPart",
    params: query
  });
}
// 子总成图总列表
export function getGroupInfo(query) {
  return request({
    method: "GET",
    url: "/getGroupInfo",
    params: query
  });
}

//获取求购信息
export function getBuyingInfo(query) {
  return request({
    method: "GET",
    url: "/getBuyingInfo",
    params: query
  });
}

//发布求购信息
export function releaseBuyingInfo(query) {
  return request({
    method: "POST",
    url: "/releaseBuyingInfo",
    data: query
  });
}
// vin码解析车型
export function vinDecodeGetCarType(query) {
  return request({
    method: "GET",
    url: "/vinDecode007",
    params: query
  });
}
// 上传图片
/* export function sendImg(query) {
  return request({
    method: "POST",
    url: "/sendImg",
    data: query
  });
} */
// 上传文件
export function sendImg (query) {
  return request({
    method: 'POST',
    url: '/sendImg',
    data: query,
    withCredentials: false,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
  }, {
      parse: true
  });
}
// 图片转成vin码
export function ocrVin(query) {
  return request({
    method: "GET",
    url: "/ocrVin",
    params: query
  });
}